module.exports = __webpack_public_path__ + "img/msg08.0a6f294b.png";